export type ConnectionIdentityStatus = "ACCEPTED" | "PENDING" | "REJECTED";

export function uniqueEntityIds(
  ...groups: Array<Iterable<string | null | undefined> | undefined>
): string[] {
  const out: string[] = [];
  const seen = new Set<string>();
  for (const group of groups) {
    if (!group) continue;
    for (const id of group) {
      if (!id || seen.has(id)) continue;
      seen.add(id);
      out.push(id);
    }
  }
  return out;
}

/** Expand each seed id with its aliases. Seed ids are always kept. */
export function applyConnectionAliases(
  seedIds: string[],
  aliasesById: Map<string, string[]>
): string[] {
  return uniqueEntityIds(
    seedIds,
    seedIds.flatMap((id) => aliasesById.get(id) ?? [])
  );
}

/**
 * Chat/directory should treat ACCEPTED as connected even if another
 * company/person alias still has PENDING or REJECTED.
 */
export function pickPreferredConnectionStatus(
  statuses: Array<ConnectionIdentityStatus | null | undefined>
): ConnectionIdentityStatus | null {
  let pending: ConnectionIdentityStatus | null = null;
  for (const status of statuses) {
    if (status === "ACCEPTED") return "ACCEPTED";
    if (status === "PENDING" && !pending) pending = status;
  }
  return pending;
}
